module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props.props) ? _c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-main__container"
  }, [_c('div', {
    staticClass: "footer-main__container--top"
  }, [_c('div', {
    staticClass: "footer-main__container--content"
  }, [_c('div', {
    staticClass: "footer-main__addresses"
  }, _vm._l((_vm.props.props.acf.footer.locations), function(address, i) {
    return _c('div', {
      staticClass: "footer-main__address"
    }, [_c('div', {
      staticClass: "footer-main__section--title",
      domProps: {
        "innerHTML": _vm._s(address.name)
      }
    }), _c('a', {
      staticClass: "footer-main__section--body",
      attrs: {
        "href": address.address_href,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(address.address)
      }
    }), _c('a', {
      staticClass: "footer-main__section--body",
      attrs: {
        "href": address.phone_href
      },
      domProps: {
        "innerHTML": _vm._s(address.phone)
      }
    }), (i === 0) ? _c('router-link', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "to": "/privacy-policy"
      }
    }, [_vm._v("Privacy Policy")]) : _vm._e()], 1)
  }), 0), _c('div', {
    staticClass: "footer-main__hours"
  }, [_c('div', {
    staticClass: "footer-main__section--title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.props.acf.footer.hours.name)
    }
  }), _c('div', {
    staticClass: "footer-main__hours--container"
  }, [_c('div', {
    staticClass: "footer-main__section--body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.props.acf.footer.hours.office_hours)
    }
  })])]), _c('div', {
    staticClass: "footer-main__buttons"
  }, [_c('div', {
    staticClass: "footer-main__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.props.acf.footer.button)
    },
    on: {
      "click": function($event) {
        return _vm.showModal(1)
      }
    }
  })])])]), _c('div', {
    staticClass: "footer-main__container--bottom"
  }, [_c('div', {
    staticClass: "footer-main__social-bar"
  }, _vm._l((_vm.props.props.acf.footer.social_bar), function(item, i) {
    return _c('a', {
      staticClass: "footer-main__item",
      attrs: {
        "href": item.icon_href,
        "target": "_blank"
      }
    }, [_c('Icon', {
      attrs: {
        "name": item.icon
      }
    })], 1)
  }), 0), _c('div', {
    staticClass: "footer-main__rg",
    domProps: {
      "innerHTML": _vm._s(_vm.props.props.acf.footer.rg)
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-280a23a7","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 635
// module chunks = 1